import FnrFetch3 from "Utilities/FnrFetch/FnrFetch3";
import { tagSentryNetwork } from "Utilities/Sentry/tagSentryNetwork";
import { fnThrowError, throwReadableError } from "Utilities/fnReportError";

const flocknoteNetworkApi = {
  getNetworkMetadata: () => new FnrFetch3(`/network/getMetadata`),
  getUserData: () => new FnrFetch3(`/user/userData`),
  getUserFundItPermissions: () => new FnrFetch3(`/user/fundItPermissions`),
  getFundItStatus: () => new FnrFetch3(`/fundit/getFundItStatus`),
  staxStatus: () => new FnrFetch3("/network/staxStatus"),
};

export const getNetworkMetadata = async () => {
  const endpoint = `/network/getMetadata`;

  const response = await new FnrFetch3(endpoint).post().catch((err) =>
    fnThrowError({
      message: `Error at ${endpoint}: ${err}`,
    })
  );
  window.fnReactBus.setMetaData(response);

  if (window.Sentry?.setContext) {
    window.Sentry.setContext("network", {
      id: response.networkID,
      name: response.networkName,
    });
  }
  tagSentryNetwork(response);

  return response;
};

export const getUserData = async () => {
  const endpoint = `/user/userData`;

  const response = await new FnrFetch3(endpoint).get().catch((err) =>
    fnThrowError({
      message: `Error at ${endpoint}: ${err}`,
    })
  );

  window.fnReactBus.setIsSuperAdmin(response.isSuperAdmin || false);

  if (window.Sentry?.setUser) {
    window.Sentry.setUser({
      id: response.userID,
      email: response.emailInfo?.email,
      username: [response.fname, response.lname].filter(Boolean).join(" "),
    });
  }

  return response;
};

export const getPermissions = async () => {
  const endpoint = `/permissions`;

  const response = await new FnrFetch3(endpoint)
    .get()
    .catch((err) => throwReadableError(endpoint, err));

  window.fnReactBus.setPermissions(response);

  return response;
};

export const getUserFundItPermissions = async () => {
  const endpoint = `/user/fundItPermissions`;

  const response = await new FnrFetch3(endpoint).get().catch((err) =>
    fnThrowError({
      message: `Error at ${endpoint}: ${err}`,
    })
  );

  return response;
};

export const getFundItStatus = async () => {
  const endpoint = `/fundit/getFundItStatus`;

  const response = await new FnrFetch3(endpoint).get().catch((err) =>
    fnThrowError({
      message: `Error at ${endpoint}: ${err}`,
    })
  );

  return response;
};

export const getStaxStatus = async () => {
  const endpoint = `/network/staxStatus`;

  const response = await new FnrFetch3(endpoint).get().catch((err) =>
    fnThrowError({
      message: `Error at ${endpoint}: ${err}`,
    })
  );

  return response;
};

export const startFNC = async () => {
  const endpoint = `/people/startSubscription`;

  const response = await new FnrFetch3(endpoint).post().catch((err) =>
    fnThrowError({
      message:
        "Uh Oh! Looks like there was an issue trying to signup for your subscription. Please reach out to help@flocknote.com",
    })
  );

  return response;
};

export default flocknoteNetworkApi;
